import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, isRef as _isRef, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-41095ecc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "content__container"
};
const _hoisted_3 = {
  class: "tree__container mg-b--15"
};
const _hoisted_4 = {
  class: "mg-l--25"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-ic_list"
}, null, -1));

const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  class: "table__container"
};
const _hoisted_8 = {
  class: "header"
};
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import TagType from '@/views/common/TagType/index.vue';
import { inject, nextTick, onMounted } from 'vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { useI18n } from 'vue-i18n';
import { debounce, getItemByProp, removePropertyOfNull } from '@/utils/tools';
import { ElTree } from 'element-plus';
import { getOperatorNameListApi, getUserByCidApi } from '@/api/authority';
import { RELEASE_STATUS_NEW, AUDIT_STATUS_NEW, RELEASE_COLOR_NEW, AUDIT_COLOR_NEW } from '@/assets/config/dicts';
import { elMessage } from '@/utils';
import { useCommon } from '@/store/useCommon';
import { getCurrentTime } from '@/utils/timeFormat';
import { getVodChannelListApi, getVodGenresOptionsApi, addVodToCategoryApi, getLangOptionsApi } from '@/api/vodNew';
const __default__ = {
  name: 'AddFilm'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,
  props: {
    returnBackFn: {
      type: Function
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const treeRef = ref(null);
    const tableRef = ref(null);
    const tableWarpRef = ref(null);
    const rowItemInfo = inject('rowItemInfo');
    console.log('rowItemInfo', rowItemInfo);
    const CODING_STATUS = {
      0: 'H.264',
      1: 'H.265'
    };
    const headerConfig = ref({
      title: '添加点播',
      btnList: [{
        label: '返回',
        func: () => {
          props.returnBackFn();
        }
      }]
    });
    const treeData = reactive({
      loading: false,
      dataList: [],
      props: {
        id: 'id',
        label: 'name'
      }
    }); // 格式化运营商列表数据

    const formateOperatorOptions = list => {
      let newList = [];
      list.forEach((item, index) => {
        newList.push({
          value: item.id,
          label: item.name,
          children: item.children != null && item.children.length > 0 ? formateOperatorOptions(item.children) : null
        });
      });
      return newList;
    }; // 获取运营商


    const getOperatorList = async () => {
      if (useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1) {
        try {
          const res = await getOperatorNameListApi();

          if (res.code == '0') {
            let item = getItemByProp(searchConfig.formList, 'cpspId');
            item.list = formateOperatorOptions(res.data);
            console.log('item', item.list);
          }
        } catch (error) {}
      } // let currentCpspid = useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1 ? sessionStorage.getItem('currentCpspid') : useCommon().userData.cpspId || 0;
      // searchConfig.formData.cpspId = currentCpspid ? Number(currentCpspid) : useCommon().userData.cpspId || 0;
      // sessionStorage.setItem('currentCpspid', String(searchConfig.formData.cpspId))

    };

    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '关键字筛选',
        prop: 'keyword',
        widgetType: 'input'
      }, {
        label: '类型',
        prop: 'programType',
        widgetType: 'Select',
        list: rowItemInfo.type == 'tv_series' ? [{
          label: t('剧集'),
          value: 'tv_series'
        }] : rowItemInfo.type == 'movie' ? [{
          label: t('单片'),
          value: 'movie'
        }] : [{
          label: t('单片'),
          value: 'movie'
        }, {
          label: t('剧集'),
          value: 'tv_series'
        }],
        change: async val => {
          await getGenres();
          tableConfig.paginationConfig.page = 1;
          getAddVodList();
        }
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        widgetType: 'Select',
        list: [{
          label: t('全部'),
          value: ''
        }, {
          label: t('已上线'),
          value: 'online'
        }, {
          label: t('已下线'),
          value: 'offline'
        }, {
          label: t('未上线'),
          value: 'not_online'
        }],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getAddVodList();
        }
      }, {
        label: '审核状态',
        prop: 'auditStatus',
        widgetType: 'Select',
        list: [{
          label: t('全部'),
          value: ''
        }, {
          label: t('已审核'),
          value: 'audited'
        }, {
          label: t('未审核'),
          value: 'unaudited'
        }, {
          label: t('终端审核'),
          value: 'terminal_audit'
        }, {
          label: t('退回审核'),
          value: 'return'
        }, {
          label: t('未通过'),
          value: 'not_approved'
        }],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getAddVodList();
        }
      }, {
        label: '语言',
        prop: 'audioLanguage',
        widgetType: 'Select',
        filterable: true,
        valueKey: 'code',
        labelKey: 'name',
        list: [],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getAddVodList();
        }
      }, {
        label: '创建时间',
        prop: 'time',
        widgetType: 'date',
        'start-placeholder': t('开始时间'),
        'end-placeholder': t('结束时间'),
        valueFormat: 'YYYY-MM-DD',
        type: 'daterange',
        change: debounce(val => {
          tableConfig.paginationConfig.page = 1;
          getAddVodList();
        }, 200)
      }, {
        label: '操作用户',
        prop: 'operatorName',
        widgetType: 'Select',
        filterable: true,
        labelKey: 'name',
        valueKey: 'id',
        list: [{
          name: t('全部'),
          id: ''
        }],
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_OU') > -1;
        },
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getAddVodList();
        }
      }, {
        label: '运营商',
        prop: 'cpspId',
        widgetType: 'treeSelect',
        filterable: true,
        list: [],
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1;
        },
        change: val => {
          tableConfig.paginationConfig.page = 1;
          getAddVodList();
        }
      }],
      formData: {
        keyword: '',
        programType: rowItemInfo.type == 'tv_series' ? 'tv_series' : 'movie',
        auditStatus: '',
        releaseStatus: '',
        audioLanguage: '',
        time: '',
        operatorName: '',
        cpspId: null
      },
      search: () => {
        treeData.loading = true;
        tableConfig.paginationConfig.page = 1;
        getAddVodList();
      },
      reset: () => {
        treeData.loading = true;
        searchData.genresId = [];
        searchData.sortType = '';
        searchData.sortField = '';
        tableRef.value.commonTableRef.clearSort();
        tableConfig.paginationConfig.page = 1;
        searchConfig.formData.programType = rowItemInfo.type == 'tv_series' ? 'tv_series' : 'movie';
        searchConfig.formData.cpspId = sessionStorage.getItem('currentCpspid') ? Number(sessionStorage.getItem('currentCpspid')) : useCommon().userData.cpspid || 0;
        treeRef.value.setCheckedKeys([]);
        getAddVodList();
      }
    });
    const tableConfig = reactive({
      data: [],
      config: {
        loading: false
      },
      isCardBlock: false,
      scrollbarAlwaysOn: true,
      paginationConfig: usePageConfig(),
      'row-key': row => {
        return row.programId;
      }
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: '影片名称',
        prop: 'name',
        sortable: 'custom',
        width: 220
      }, {
        label: '类型',
        prop: 'programType',
        width: 90,
        formatter: value => {
          return value == 'movie' ? t('单片') : value == 'tv_series' ? t('剧集') : '';
        }
      }, {
        label: '审核状态',
        prop: 'auditStatus',
        cellSlot: true,
        width: 160,
        sortable: 'custom'
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        cellSlot: true,
        width: 160,
        sortable: 'custom'
      }, {
        label: '语言',
        prop: 'audioLanguage',
        width: 120,
        sortable: 'custom'
      }, {
        label: '编码协议',
        prop: 'videoCode',
        width: 120,
        sortable: 'custom' // formatter: (value: any) => {
        //   if (value) {
        //     let arr = value.split(',');
        //     const res = arr.map(item => CODING_STATUS[Number(item)]);
        //     return res.join();
        //   }
        // }

      }, {
        label: '分类属性',
        prop: 'genres',
        width: 150,
        sortable: 'custom' // formatter: (value: any) => {
        //   if (value) {
        //     let arr = value.split(',');
        //     let res = [];
        //     arr.forEach(item => {
        //      let fItem = oldGenresList.value.find(genres => genres.id == item);
        //       fItem ? res.push(fItem.name) : '';
        //     })
        //     return res.join();
        //   }
        // }

      }, {
        label: '操作用户',
        prop: 'operatorName',
        width: 150,
        sortable: 'custom'
      }, {
        label: '创建时间',
        prop: 'createTime',
        sortable: 'custom',
        width: 170,
        formatter: val => val && getCurrentTime(val)
      }]
    });
    const productOperationsCid = ref(sessionStorage.getItem('productOperationsCid')); // 搜索查询用额外到的参数

    const searchData = reactive({
      genresId: [],
      sortType: '',
      sortField: ''
    });
    const isShowAside = ref(true);
    const Tags = computed(() => {
      let common = [];
      return isShowAside.value ? common : [{
        type: 'close',
        name: '',
        noActive: true,
        icon: 'icon-ic_list'
      }, ...common];
    });
    const selectTableConfig = reactive({
      selectData: [] // table已勾选的数据列表

    }); // table复选框点击事件

    const handleSelectionChange = val => {
      selectTableConfig.selectData = val;
    }; // 获取所有语言


    const getAllLanguages = async () => {
      const res = await getLangOptionsApi();
      let langueList = res.data.map(item => {
        return { ...item,
          labelValue: item.label
        };
      });
      let languageList = getItemByProp(searchConfig.formList, 'audioLanguage');
      languageList.list = [{
        name: t('全部'),
        value: '',
        labelValue: '',
        code: ''
      }, ...langueList];
    }; // 获取操作用户


    const getUserByCid = async params => {
      if (useCommon().userData.permissionKey.indexOf('DC_OU') > -1) {
        let item = getItemByProp(searchConfig.formList, 'operatingUser');

        try {
          const res = await getUserByCidApi(params);

          if (res.code == '0') {
            // item.list = [{ agentName: t('全部'), id: '' }, ...res.data]
            item.list = [{
              name: t('全部'),
              id: ''
            }, ...res.data.sort(function (a, b) {
              return a.name.trim().localeCompare(b.name.trim());
            })];
          }
        } catch (error) {}

        getAddVodList();
      } else {
        getAddVodList();
      }
    }; // 获取数据列表


    const getAddVodList = async () => {
      !tableConfig.config.loading ? tableConfig.config.loading = true : '';
      let params = {
        cid: productOperationsCid.value,
        ...searchData,
        pageNo: tableConfig.paginationConfig.page,
        pageSize: tableConfig.paginationConfig.limit,
        ...searchConfig.formData,
        listType: 1,
        categoryId: rowItemInfo.id,
        language: localStorage.getItem('language') || 'en' // 返回的数据中的分类属性国际化

      }; // 整理创建时间参数

      if (params.time && params.time.length) {
        params.startTime = params.time[0];
        params.endTime = params.time[1];
        params.time = [];
      }

      try {
        // const res = await getAddVodInfoApi(params) as any
        const res = await getVodChannelListApi(removePropertyOfNull(params));

        if (res.code == '0') {
          tableConfig.data = res.data.records;
          tableConfig.paginationConfig.total = res.data.total;
        } // vodInfo.value.objIds.forEach(vodInfoItem => {
        //   tableRef.value.commonTableRef.toggleRowSelection(vodInfoItem, true)
        // })

      } catch (error) {}

      oldGenresList.value = JSON.parse(JSON.stringify(genresList.value));
      tableConfig.config.loading = false;
      treeData.loading = false;
    }; // 底部取消按钮点击事件


    const onCancel = () => {
      props.returnBackFn();
    }; // 底部确认按钮点击事件


    const onConfirm = debounce(async () => {
      if (selectTableConfig.selectData.length === 0) {
        return elMessage('warning', '请先勾选需要添加的影片');
      } else {
        try {
          let idTypeList = selectTableConfig.selectData.filter(item => vodInfo.value.ids.indexOf(item.programId) == -1);
          idTypeList = idTypeList.map(item => {
            return {
              programId: item.programId,
              programType: item.programType
            };
          });
          let params = {
            categoryId: rowItemInfo.id,
            idTypeList
          };
          console.log('选择的数据', selectTableConfig.selectData);
          let categoryProgramIds = selectTableConfig.selectData.map(item => item.id);
          let newParams = {
            categoryId: rowItemInfo.id,
            categoryProgramIds
          };

          if (selectTableConfig.selectData.length > 0) {
            // const res = await addVodInfoApi(params) as ResType
            const res = await addVodToCategoryApi(newParams);

            if (res.code == '0') {
              elMessage('success', '新增成功');
              props.returnBackFn();
            }
          } else {
            elMessage('success', '新增成功');
            props.returnBackFn();
          }
        } catch (error) {}
      }
    }, 200); // 处理点击事件

    const handleTagClick = tag => {
      closeAside();
    }; // 是否显示table表格


    const isShowTable = ref(true); // 关闭侧边栏

    const closeAside = () => {
      isShowAside.value = !isShowAside.value;
      isShowTable.value = false;
      nextTick(() => {
        // 防止关闭侧边栏flex布局影响table拉伸问题
        isShowTable.value = true;
      });
    }; // el-tree复选框点击事件


    const handleCheck = (data, change) => {
      let nodes = treeRef.value.getCheckedNodes().concat(treeRef.value.getHalfCheckedNodes());
      searchData.genresId = nodes.map(item => item.id);
      tableRef.value && tableRef.value.commonTableRef.clearSelection();
      getAddVodList();
    };

    const genresList = ref([]); // 分类属性数据缓存,避免下拉切换造成视图数据影响

    const oldGenresList = ref([]); // 获取分类属性

    const getGenres = async () => {
      treeData.loading = true;
      genresList.value = [];
      treeData.dataList = []; //const res = await useGenresList(localStorage.getItem('language') || 'en', 0)

      const res = await getVodGenresOptionsApi({
        language: localStorage.getItem('language') || 'en'
      });
      setTimeout(() => {
        genresList.value = res.data;
        treeData.dataList = res.data;
        treeData.loading = false;
      }, 200);
    }; // 表格复选框回显数据id


    const vodInfo = ref({
      ids: [],
      objIds: []
    }); // 表格排序

    const handleSortChange = debounce(async params => {
      // console.log(params);
      if (params.order) {
        const sortType = params.order.replace('ending', '');
        searchData.sortType = sortType;
        searchData.sortField = params.prop == 'releaseStatus' ? 'releasestatus' : params.prop;
        getAddVodList();
      } else {
        searchData.sortType = '';
        searchData.sortField = '';
        getAddVodList();
      }
    }, 200);
    watch(() => tableConfig.data, val => {
      const columntree = document.querySelector('#columntree');
      nextTick(() => {
        columntree.style.height = tableWarpRef.value.offsetHeight - 50 + 'px';
      });
    });
    onMounted(async () => {
      // getVodInfoIds()
      let cpspid = useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1 ? sessionStorage.getItem('currentCpspid') ? Number(sessionStorage.getItem('currentCpspid')) : useCommon().userData.cpspid || 0 : useCommon().userData.cpspid || 0;
      searchConfig.formData.cpspId = cpspid;
      tableConfig.config.loading = true;
      getOperatorList();
      getGenres();
      getAllLanguages();
      getUserByCid({
        cid: productOperationsCid.value
      });
    });
    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_ButtomBtns = _resolveComponent("ButtomBtns");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ActionHeader, {
        config: headerConfig.value
      }, null, 8, ["config"]), _createVNode(_component_search_form, {
        size: searchConfig.size,
        gutter: 30,
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: searchConfig.search,
        onReset: searchConfig.reset
      }, null, 8, ["size", "form-list", "form-data", "onSearch", "onReset"]), _createElementVNode("div", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("header", null, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('分类属性')), 1), _createElementVNode("span", {
        onClick: closeAside,
        class: "mg-r--25 aside__cursor"
      }, _hoisted_6)]), _createVNode(_unref(ElTree), {
        "empty-text": !treeData.loading && treeData.dataList.length === 0 ? _ctx.$t('暂无数据') : '',
        ref_key: "treeRef",
        ref: treeRef,
        "node-key": "id",
        "default-expand-all": "",
        onCheck: handleCheck,
        data: treeData.dataList,
        props: treeData.props,
        "show-checkbox": "",
        id: "columntree"
      }, null, 8, ["empty-text", "data", "props"])])), [[_vShow, isShowAside.value], [_directive_loading, treeData.loading]]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(TagType, {
        modelValue: _unref(Tags),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(Tags) ? Tags.value = $event : null),
        onOnTagClick: handleTagClick
      }, null, 8, ["modelValue"])]), _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "cms-card-block table-list",
        ref_key: "tableWarpRef",
        ref: tableWarpRef
      }, [isShowTable.value ? (_openBlock(), _createBlock(_component_common_table, {
        key: 0,
        dynamicTableMaxHeight: "",
        "show-title": false,
        "option-column-list": columnConfig.columnList,
        ref_key: "tableRef",
        ref: tableRef,
        style: {
          "width": "100%"
        },
        "pagination-config": tableConfig.paginationConfig,
        "table-config": tableConfig,
        render: getAddVodList,
        onSelectionChange: handleSelectionChange,
        onSortChange: _unref(handleSortChange)
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property === 'releaseStatus' ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle([{
              "white-space": "nowrap",
              "overflow": "hidden",
              "text-overflow": "ellipsis"
            }, 'color:' + _unref(RELEASE_COLOR_NEW)[scope.row.releaseStatus]])
          }, _toDisplayString(_unref(RELEASE_STATUS_NEW)[scope.row.releaseStatus]), 5)) : _createCommentVNode("", true), scope.column.property === 'auditStatus' ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            style: _normalizeStyle([{
              "white-space": "nowrap",
              "overflow": "hidden",
              "text-overflow": "ellipsis"
            }, 'color:' + _unref(AUDIT_COLOR_NEW)[scope.row.auditStatus]])
          }, _toDisplayString(_unref(AUDIT_STATUS_NEW)[scope.row.auditStatus]), 5)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["option-column-list", "pagination-config", "table-config", "onSortChange"])) : _createCommentVNode("", true), _createVNode(_component_ButtomBtns, {
        style: {
          "margin-top": "50px"
        },
        onOnCancel: onCancel,
        onOnConfirm: _unref(onConfirm),
        confirmDisabled: !selectTableConfig.selectData.length
      }, null, 8, ["onOnConfirm", "confirmDisabled"])])), [[_directive_loading, tableConfig.config.loading]])])])]);
    };
  }

});